/**
 * `BackdropSceneRow` — the Director's 03 SCENE line for the narrative backdrop (`narrative-backdrop`
 * 1.4): `Backdrop: Verdigris` with CLEAR while one is pinned, or a pointer to where one is pinned
 * from (a place's CODEX file) when none is. Self-contained: it reads the session and the codex itself,
 * so the Director drops it in with no props.
 */
import { useGameSessionContext } from "../../../../lib/game/GameSessionProvider";
import { useBackdropEntry } from "./useBackdropEntry";
import "./backdropRow.css";

export function BackdropSceneRow() {
  const session = useGameSessionContext();
  const entry = useBackdropEntry();
  const pinned = session.backdrop;
  return (
    <div className="bdrow" data-testid="director-backdrop" aria-label="Narrative backdrop">
      <span className="bdrow-label">BACKDROP</span>
      {pinned === null ? (
        <span className="bdrow-none">None · pin a world from its CODEX file</span>
      ) : (
        <>
          <span className="bdrow-name">{entry?.name ?? pinned}</span>
          <button type="button" className="bdrow-clear" onClick={() => session.setBackdrop(null)}>
            CLEAR
          </button>
        </>
      )}
    </div>
  );
}
